import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Download, FileText, FileSpreadsheet } from "lucide-react";
import { exportCSV, exportPDF } from "@/lib/exportUtils";
import { toast } from "sonner";

// columns: [{ header, key | accessor(row) }]
export const ExportMenu = ({ filename = "export", title = "Export", columns = [], rows = [], testid = "export-menu" }) => {
  const run = (fn, label) => {
    if (!rows.length) return toast.error("Nothing to export yet");
    try { fn(); } catch (e) { toast.error(`${label} export failed`); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="rounded-full" data-testid={testid}>
          <Download className="w-4 h-4 mr-1.5" />Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem data-testid={`${testid}-csv`} onClick={() => run(() => exportCSV(filename, columns, rows), "CSV")}>
          <FileSpreadsheet className="w-4 h-4 mr-2" />Download CSV
        </DropdownMenuItem>
        <DropdownMenuItem data-testid={`${testid}-pdf`} onClick={() => run(() => exportPDF(title, columns, rows), "PDF")}>
          <FileText className="w-4 h-4 mr-2" />Download PDF
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
